import { Card, Checkbox, Heading, Stack, Text } from "@softmax/design-system";
import type { AccountProfileDraft } from "./profile-state";

export function CommunicationPreferences({
  profile,
  onProfileChange,
}: {
  readonly profile: Pick<
    AccountProfileDraft,
    "consentServiceUpdates" | "consentMarketing"
  >;
  readonly onProfileChange: (changes: Partial<AccountProfileDraft>) => void;
}) {
  return (
    <Card>
      <Stack width="auto">
        <Heading level={2}>Communication preferences</Heading>
        <Checkbox
          checked={profile.consentServiceUpdates}
          onCheckedChange={(checked) =>
            onProfileChange({ consentServiceUpdates: checked })
          }
        >
          Service updates
        </Checkbox>
        <Text as="p" size="small" tone="muted">
          Email me about important product and service updates.
        </Text>
        <Checkbox
          checked={profile.consentMarketing}
          onCheckedChange={(checked) =>
            onProfileChange({ consentMarketing: checked })
          }
        >
          Announcements
        </Checkbox>
        <Text as="p" size="small" tone="muted">
          Email me about launches and events.
        </Text>
      </Stack>
    </Card>
  );
}
